import { handleUpdateWebinar } from "../../../../../redux/specialist-slices/webinar.slice";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { webinarResourcesSchema } from "../../../../../utils/velidations";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Fragment } from "react";

function PreviewUpadte({ data, setValue }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loadings } = useSelector((state) => state.otherSlice);

  const { id: webinarId } = useParams();

  const handleCreate = async (e) => {
    e.preventDefault();
    
    delete data?.current;
    const webinarData = {
      file: data.resources?.files?.[0] || null,
      webinarLink: data.resources?.webinarLink || "",
    };

    const result = webinarResourcesSchema.safeParse(webinarData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      return;
    }

    const payload = {
      ...data.details,
      ...data.schedule,
      ...data.format,
      ...data.resources,
      coverImage: data?.details?.coverImage || null,
      files: data?.resources?.files || [],
    };

    try {
      const response = await dispatch(
        handleUpdateWebinar({ id: webinarId, data: payload })
      ).unwrap();

      if (response) {
        navigate("/specialist/profile/webinars/all");
      }
    } catch (error) {
      console.error("Update error:", error);
    }
  };

  return (
    <Fragment>
      <Typography variant="typographyA">Schedule & Duration</Typography>
      <Stack spacing={2}>
        <Box>
          <Typography variant="bodyLead">Webinar Basics</Typography>
          <Typography>
            <b>Title : </b>
            {data?.details?.title || "Not provided"}
          </Typography>
          <Typography>
            <b>Description : </b>
            {data?.details?.description || "Not provided"}
          </Typography>
          <Typography>
            <b>Target Audience : </b>
            {Array.isArray(data?.details?.targetAudience)
              ? data.details.targetAudience.join(", ")
              : data?.details?.targetAudience || "Not provided"}{" "}
          </Typography>
          <Typography>
            <b>Number of Seats : </b>
            {data?.details?.numberOfSeats || "Not provided"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="bodyLead">Schedule & Duration</Typography>
          <Typography>
            <b>Date : </b>
            {data?.schedule?.date || "Not provided"}
          </Typography>
          <Typography>
            <b>Duration : </b>
            {data?.schedule?.duration || "Not provided"}
          </Typography>
          <Typography>
            <b>Time Zone : </b>
            {data?.schedule?.timeZone || "Not provided"}
          </Typography>
          <Typography>
            <b>Start Time : </b>
            {data?.schedule?.startTime || "Not provided"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="bodyLead">Format & Access</Typography>
          <Typography>
            <b>Format : </b>
            {data?.format?.format || "Not provided"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="bodyLead">Resources</Typography>
          <Typography>
            <b>Files : </b>{" "}
            {data?.resources?.files?.length > 0
              ? data.resources.files.map((file, i) => (
                  <span key={i}>{file.name || file.originalName}</span>
                ))
              : "Not provided"}
          </Typography>
          <Typography>
            <b>Webinar Link : </b>
            {data?.resources?.webinarLink || "Not provided"}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button
            size="large"
            variant="contained"
            sx={{ minWidth: 150 }}
            disabled={loadings?.create}
            onClick={() => {
              setValue("resources");
            }}
          >
            Back
          </Button>
          <Button
            size="large"
            variant="contained"
            sx={{ minWidth: 150 }}
            onClick={handleCreate}
            disabled={loadings?.create}
            endIcon={
              loadings?.create && (
                <CircularProgress size={22} color="text" thickness={6} />
              )
            }
          >
            Submit for Review
          </Button>
        </Stack>
      </Stack>
    </Fragment>
  );
}

export default PreviewUpadte;
